// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconSort = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11">
            <path
                fill="currentColor"
                d="M0.648284591,4.500633 L6.85219113,4.500633 C7.42875377,4.500633 7.71680013,3.80266428 7.31016008,3.39625812 L4.20937876,0.190008402 C4.08267549,0.0633051395 3.9171131,0 3.75164441,0 C3.58629302,0 3.42141012,0.0633051395 3.29578511,0.190008402 L0.190292395,3.39672661 C-0.216301524,3.80219543 0.0716046462,4.500633 0.648284234,4.500633 L0.648284591,4.500633 Z M6.85078386,6.000633 L0.648284234,6.000633 C0.0717215905,6.000633 -0.216325127,6.69836712 0.190315641,7.10500789 L3.29578439,10.3112576 C3.41953436,10.4373515 3.56484715,10.500633 3.75000326,10.500633 C3.9153078,10.500633 4.08094064,10.4372814 4.2077376,10.3105781 L7.30851928,7.10432839 C7.71562854,6.69907022 7.42734686,6.000633 6.85078422,6.000633 L6.85078386,6.000633 Z"
                transform="translate(.25 .25)"
            />
        </svg>
    );
};

export default React.memo(IconSort);
